import React from 'react';

import CmsArticle from './CmsArticle';
import JobAd from './JobAd';
import { Recommendation } from '../../types'
import Tracking from '../../tracking';

type AdsProps = {
    items: Recommendation[];
    imagesCdnUrl: string;
    tracking: Tracking;
    trackAdClick: (adId: string, trackingUrlClick: string[]) => void;
    favoriteHeart: (itemId: string) => React.ReactNode;
}

const Ads: React.FC<AdsProps> = (props) => {
    const {
        items,
        imagesCdnUrl,
        tracking,
        trackAdClick,
        favoriteHeart,
    } = props;

    return (
        <div className="grid f-grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 mx-10">
            {items.map((item) => {
                switch (item.renderType) {
                    case "CMS":
                        return (
                            <CmsArticle
                                item={item}
                                tracking={tracking}
                                trackAdClick={trackAdClick}
                            />
                        );
                    default:
                        // JOB
                        return (
                            <JobAd
                                item={item}
                                imagesCdnUrl={imagesCdnUrl}
                                tracking={tracking}
                                trackAdClick={trackAdClick}
                                favoriteHeart={favoriteHeart}
                            />
                        );
                }
            })}
        </div>
    );
};

export default Ads;
